import type { CSSProperties } from "react";
import { PLATFORM_BRAND } from "../../config/platformBrand";
import styles from "./PoweredBy.module.css";

type PoweredByProps = {
  className?: string;
  style?: CSSProperties;
};

const PoweredBy: React.FC<PoweredByProps> = ({ className, style }) => {
  return (
    <p className={`${styles.root} ${className ?? ""}`} style={style}>
      {PLATFORM_BRAND.queueName}
    </p>
  );
};

export default PoweredBy;
